import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Header from './Header';
import { headerHeight } from '../modules/theme';
import './styles.css';

const Content = styled.div`
  padding-top: ${headerHeight}px;
`;

export default class MenuPage extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    onLogout: PropTypes.func.isRequired,
    profile: PropTypes.object,
    role: PropTypes.string,
  };

  render() {
    const { profile, onLogout, role } = this.props;

    return (
      <div>
        <Header profile={profile} logOut={onLogout} role={role} />
        <Content className="pageContent">{this.props.children}</Content>
      </div>
    );
  }
}
